/**
 * Lo que va a costar la cobertura, pedido al backend ANTES de cobrar.
 *
 * Mike, 9-oct: "The insurance must be a line item." Y la regla de siempre: se
 * cobra lo que se muestra. El precio sale de la tarifa del comerciante (o del
 * precio del tier), asi que no se calcula aca: se pregunta.
 *
 * Mike pidio el 4-oct no mostrar el precio en el formulario del seguro, asi
 * que esto se usa solo donde se confirma la compra.
 */
import { useEffect, useState } from 'react';
import { apiErrorMessage } from './apiError';
import { formatMoney } from './api';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const dinero = formatMoney;

/**
 * Devuelve { precio, error }. Antes devolvia solo el precio, y "cargando" y
 * "fallo" eran el mismo null: en Rate Shop el boton quedaba en "…" para
 * siempre sin decir por que, y en las pantallas que emiten cobertura el boton
 * perdia el precio y cobraba igual. Sin precio no se emite.
 */
export function usePrecioCobertura({ token, tier, declared, category, resale = false, enabled = true }) {
  const [precio, setPrecio] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const valor = parseFloat(declared) || 0;
    if (!enabled || !token || !tier || valor <= 0) {
      setPrecio(null);
      setError(null);
      return undefined;
    }
    let vivo = true;
    setPrecio(null);
    setError(null);
    const espera = setTimeout(async () => {
      try {
        const r = await fetch(`${API}/insurance/selletrans/price`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            coverage_tier: tier,
            declared_value: valor,
            commodity_category: category || undefined,
            is_resale: !!resale,
          }),
        });
        const d = await r.json().catch(() => null);
        if (!vivo) return;
        if (r.ok && d) { setPrecio(d); return; }
        setError(apiErrorMessage(d, 'The coverage price could not be loaded.'));
      } catch (e) {
        if (vivo) setError('The coverage price could not be loaded.');
      }
    }, 300);
    return () => { vivo = false; clearTimeout(espera); };
  }, [token, tier, declared, category, resale, enabled]);

  return { precio, error };
}
